webpackJsonp([1],{

/***/ "1JuB":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "CPGk":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export makeRandom */
/* unused harmony export arrayFind */
/* harmony export (immutable) */ __webpack_exports__["b"] = isBrower;
/* unused harmony export getAppid */
/* unused harmony export getApiUrl */
/* harmony export (immutable) */ __webpack_exports__["c"] = makeUrl;
/* harmony export (immutable) */ __webpack_exports__["a"] = getParamsFromUrl;
/* unused harmony export queryBuilder */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof__ = __webpack_require__("pFYg");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys__ = __webpack_require__("fZjL");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__config__ = __webpack_require__("rvz5");




/**
 * 生成指定长度随机数
 * @param length
 * @returns {string}
 */
function makeRandom(length) {
  var str = "0123456789",
      ret = "";
  for (var i = 0; i < length; i++) {
    ret += str.substr(Math.floor(Math.random() * str.length), 1);
  }
  return ret;
}

/**
 * 根据条件返回数组指定元素
 * @param array
 * @param fn
 * @returns {null}
 */
function arrayFind(array, fn) {
  var index = array.findIndex(fn);
  return index > -1 ? array[index] : null;
}

/**
 * 判断浏览器类型
 * @param name
 * iphone
 * android
 * micromessenger
 * @returns {boolean}
 */
function isBrower(name) {
  var UA = window.navigator.userAgent.toLowerCase();
  return UA.indexOf(name) > -1;
}

function getAppid(callback) {
  var hostname = url("hostname", callback);
  var appid = "";
  for (var key in __WEBPACK_IMPORTED_MODULE_2__config__["a" /* default */].appid) {
    if (hostname == key) {
      appid = __WEBPACK_IMPORTED_MODULE_2__config__["a" /* default */].appid[key];
    }
  }
  if (!appid) {
    appid = __WEBPACK_IMPORTED_MODULE_2__config__["a" /* default */].appid[__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default()(__WEBPACK_IMPORTED_MODULE_2__config__["a" /* default */].appid)[0]];
  }
  return appid;
}

/**
 * 根据来源获得api_url
 * @param callback
 * @returns {string}
 */
function getApiUrl(callback) {
  var hostname = url("hostname", callback);
  var api_url = "";
  for (var key in __WEBPACK_IMPORTED_MODULE_2__config__["a" /* default */].api_url) {
    if (hostname == key) {
      api_url = __WEBPACK_IMPORTED_MODULE_2__config__["a" /* default */].api_url[key];
    }
  }
  if (!api_url) {
    api_url = __WEBPACK_IMPORTED_MODULE_2__config__["a" /* default */].api_url[__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default()(__WEBPACK_IMPORTED_MODULE_2__config__["a" /* default */].api_url)[0]];
  }
  return api_url;
}

/**
 * 生成跳转链接
 * @param options
 * @returns {string}
 */
function makeUrl(options) {
  var url = "";
  if (options.protocol) {
    url += options.protocol + "://";
  }
  if (options.hostname) {
    url += options.hostname;
  }
  if (options.port && options.port != 80 && options.port != 443) {
    url += ":" + options.port;
  }
  if (options.path) {
    url += options.path;
  }
  if (options.query) {
    var q = "";
    for (var key in options.query) {
      if (options.query[key]) {
        q += "&" + key + "=" + encodeURIComponent(options.query[key]);
      } else {
        q += "&" + key;
      }
    }
    q = q.substr(1);
    url += "?" + q;
  }
  if (options.hash) {
    url += "#" + options.hash;
  }
  return url;
}

/**
 * 解析url参数
 * @param from
 * @returns {{protocol: *, hostname: *, port: *, path: *, query: *, hash: *}}
 */
function getParamsFromUrl(from) {
  var protocol = url("protocol", from);
  var hostname = url("hostname", from);
  var port = url("port", from);
  var path = url("path", from);
  var query = url("?", from);
  var hash = url("hash", from);
  return { protocol: protocol, hostname: hostname, port: port, path: path, query: query, hash: hash };
}

/**
 * 生成query字符串
 * @param query
 * @returns {string}
 */
function queryBuilder(query) {
  if ((typeof query === "undefined" ? "undefined" : __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof___default()(query)) !== 'object') {
    return '';
  }
  var queryStr = '';
  for (var key in query) {
    queryStr += "&" + key + "=" + encodeURIComponent(query[key]);
  }
  return queryStr.substr(1);
}

/***/ }),

/***/ "M93x":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_script_index_0_App_vue__ = __webpack_require__("sEFh");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_13_7_3_vue_loader_lib_template_compiler_index_id_data_v_f1cb7872_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_template_index_0_App_vue__ = __webpack_require__("ezy0");
function injectStyle (ssrContext) {
  __webpack_require__("1JuB")
}
var normalizeComponent = __webpack_require__("C7Lr")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_script_index_0_App_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_13_7_3_vue_loader_lib_template_compiler_index_id_data_v_f1cb7872_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_template_index_0_App_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "NHnr":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__("7+uW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__App__ = __webpack_require__("M93x");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_cookies__ = __webpack_require__("ppUw");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_cookies___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_vue_cookies__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_polyfill__ = __webpack_require__("j1ja");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_polyfill___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_polyfill__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__sentry_browser__ = __webpack_require__("rnrV");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__sentry_browser___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__sentry_browser__);
// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.







"production" === 'production' && __WEBPACK_IMPORTED_MODULE_4__sentry_browser__["init"]({
  dsn: 'https://4e1d487fd4744afd932c4347edb3cfd6@sentry.io/1299841',
  integrations: [new __WEBPACK_IMPORTED_MODULE_4__sentry_browser__["Integrations"].Vue({ Vue: __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */] })]
});

__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_2_vue_cookies___default.a);

__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].config.productionTip = false;

//oauth2(init);
init();

function init() {
  /* eslint-disable no-new */
  new __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */]({
    el: '#app',
    template: '<App/>',
    components: { App: __WEBPACK_IMPORTED_MODULE_1__App__["a" /* default */] }
  });
}

/***/ }),

/***/ "ezy0":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticStyle:{"font-size":"1em"},attrs:{"id":"app"}},[(_vm.query&&_vm.query.debug)?_c('div',[_c('h3',{on:{"click":function($event){return _vm.goOauth2(_vm.hrefParams)}}},[_vm._v("去授权")]),_vm._v(" "),_c('h3',{on:{"click":function($event){return _vm.goBack(_vm.hrefParams,true)}}},[_vm._v("返回")]),_vm._v(" "),_c('pre',{staticStyle:{"font-size":"14px"}},[_vm._v(_vm._s(_vm.query))]),_vm._v(" "),_c('pre',{staticStyle:{"font-size":"14px"}},[_vm._v(_vm._s(_vm.hrefParams))]),_vm._v(" "),_c('pre',{staticStyle:{"font-size":"14px"}},[_vm._v(_vm._s(_vm.cookie))])]):_vm._e()])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "rvz5":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  key_prefix: "dev_oauth2_",
  password: "aAr9MVS9j1",
  api_url: {
    "localhost": "//nethos.diandianys.com/api/app",
    "nethosweb.diandianys.com": "//nethos.diandianys.com/api/app",
    "test-zheer-wx.hztywl.cn": "//nethos.diandianys.com/api/app",
    "pat-test.gjwlyy.com": "//api-test.gjwlyy.com/api/app",
    "www.gjwlyy.com": "http://api.teyangsoft.com/?service=gjwlyy&action=index&sign=1ea3f0c0dd0c91ee54e546a99beafbfb"
  },
  appid: {
    "localhost": "wxa49f90b4ff678ef2",
    "nethosweb.diandianys.com": "wxa49f90b4ff678ef2",
    "test-zheer-wx.hztywl.cn": "wxa49f90b4ff678ef2",
    "pat-test.gjwlyy.com": "wx3d274480f31f6de2",
    "www.gjwlyy.com": "wx3d274480f31f6de2"
  },
  alipay_appid: {
    "nethos-webtest.diandianys.com": "2016021701147425",
    "www.gjwlyy.com": "2014102300014454"
  },
  alipay_oauth2: {
    "nethos-webtest.diandianys.com": "http://nethosapi.diandianys.com",
    "www.gjwlyy.com": "https://api.gjwlyy.com"
  },
  base_params: {
    channel: "4",
    format: "JSON",
    oper: "127.0.0.1",
    spid: "1001"
  }
});

/***/ }),

/***/ "sEFh":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(Log) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__lib_util__ = __webpack_require__("CPGk");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__lib_config__ = __webpack_require__("rvz5");
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'app',
  data: function data() {
    return {
      brower: '',
      page: "",
      hrefParams: {},
      query: {},
      cookies: "",
      cookie: ''
    };
  },
  created: function created() {
    Log('浏览器信息', window.navigator.userAgent);
    //微信打开
    var hrefParams = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__lib_util__["a" /* getParamsFromUrl */])(location.href);
    this.hrefParams = hrefParams;
    this.query = hrefParams.query || {};
    this.cookie = document.cookie;
    if (this.query.debug) {
      eruda.init();
    }

    if (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__lib_util__["b" /* isBrower */])("micromessenger")) {
      this.brower = 'weixin';
      this.weixinInit();
    } else if (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__lib_util__["b" /* isBrower */])('alipayclient')) {
      this.brower = 'alipay';
      this.alipayInit();
    } else {
      //非微信支付宝打开
    }
  },

  methods: {
    alipayInit: function alipayInit() {
      var p = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__lib_util__["a" /* getParamsFromUrl */])(location.href);
      if (!p.query) {
        alert("get参数不能为空");
        return;
      }
      var APPID = __WEBPACK_IMPORTED_MODULE_1__lib_config__["a" /* default */].alipay_appid[location.hostname];
      var cookie = this.$cookies.get('alipayuserid_' + APPID);
      if (cookie) {
        cookie = cookie.split('_');

        var _getParamsFromUrl = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__lib_util__["a" /* getParamsFromUrl */])(p.query.callback),
            protocol = _getParamsFromUrl.protocol,
            hostname = _getParamsFromUrl.hostname,
            port = _getParamsFromUrl.port,
            path = _getParamsFromUrl.path,
            query = _getParamsFromUrl.query,
            hash = _getParamsFromUrl.hash;

        if (!query) {
          query = { openid: cookie[0], next: cookie[1] || '' };
        } else {
          query.openid = cookie[0];
          query.next = cookie[1] || '';
        }
        query.t = new Date().getTime();
        this.clearCookies();
        var red = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__lib_util__["c" /* makeUrl */])({ protocol: protocol, hostname: hostname, port: port, path: path, query: query, hash: hash });
        console.log('重定向地址', red);
        location.href = red;
      } else {
        this.goOauth2();
      }
    },
    weixinInit: function weixinInit() {
      var p = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__lib_util__["a" /* getParamsFromUrl */])(location.href);
      if (!p.query) {
        alert("get参数不能为空");
        return;
      }
      var openid = this.$cookies.get('openid_' + p.query.appid) || '';
      if (!openid) openid = p.query.openid;
      if (openid) {
        console.log('cb', p.query.callback);

        var _getParamsFromUrl2 = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__lib_util__["a" /* getParamsFromUrl */])(p.query.callback),
            protocol = _getParamsFromUrl2.protocol,
            hostname = _getParamsFromUrl2.hostname,
            port = _getParamsFromUrl2.port,
            path = _getParamsFromUrl2.path,
            query = _getParamsFromUrl2.query,
            hash = _getParamsFromUrl2.hash;
        //console.log('query', query);


        if (!query) {
          query = { openid: openid };
        } else {
          query.openid = openid;
        }
        query.t = new Date().getTime();
        //this.clearCookies();
        var red = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__lib_util__["c" /* makeUrl */])({ protocol: protocol, hostname: hostname, port: port, path: path, query: query, hash: hash });
        console.log('重定向地址', red);
        location.href = red;
      } else {
        this.goOauth2(p);
      }
    },


    //http://test-wechat-repeater.hztywl.cn/wechat/plat/oauth/wxa49f90b4ff678ef2?url=https%3a%2f%2fwww.baidu.com&scope=snsapi_userinfo
    goOauth2: function goOauth2(p) {
      var _location = location,
          hostname = _location.hostname;

      var APPID = __WEBPACK_IMPORTED_MODULE_1__lib_config__["a" /* default */].alipay_appid[location.hostname];
      if (this.brower === 'weixin') {
        location.replace('http://' + (p.query.plat && p.query.plat === 'pro' ? "" : "test-") + 'wechat-repeater.hztywl.cn/wechat/plat/oauth/' + p.query.appid + '?url=' + encodeURIComponent(location.href) + '&scope=snsapi_userinfo');
      } else if (this.brower === 'alipay') {
        location.replace(__WEBPACK_IMPORTED_MODULE_1__lib_config__["a" /* default */].alipay_oauth2[hostname] + '/alipay/oauth/' + APPID + '?scope=auth_user&url=' + encodeURIComponent(location.href));
      }
    },
    goBack: function goBack(p) {
      var showRed = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

      var openid = this.$cookies.get('openid_' + p.query.appid);

      var _getParamsFromUrl3 = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__lib_util__["a" /* getParamsFromUrl */])(p.query.callback),
          protocol = _getParamsFromUrl3.protocol,
          hostname = _getParamsFromUrl3.hostname,
          port = _getParamsFromUrl3.port,
          path = _getParamsFromUrl3.path,
          query = _getParamsFromUrl3.query,
          hash = _getParamsFromUrl3.hash;
      //console.log('query', query);


      if (!query) {
        query = { openid: openid };
      } else {
        query.openid = openid;
      }
      query.t = new Date().getTime();
      this.clearCookies();
      var red = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__lib_util__["c" /* makeUrl */])({ protocol: protocol, hostname: hostname, port: port, path: path, query: query, hash: hash });
      console.log('重定向地址', red);
      if (showRed) alert(red);
      location.href = red;
    },
    clearCookies: function clearCookies() {
      var _this = this;

      this.$cookies.keys().forEach(function (res) {
        console.log(res, _this.$cookies.remove(res, '/', '.hztywl.cn'));
      });
    }
  },
  watch: {}
});
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__("lotU")))

/***/ })

},["NHnr"]);


// WEBPACK FOOTER //
// static/js/app.905a9f17e4cab581d900.js